import { matchesQuery } from "./utils/searchUtils";
export function findFileWithFallback(availableFiles, filename) {
  if (!filename || !availableFiles) return null;
  const matchesFilename = (f, name) => f.name === name || f.path.endsWith("/" + name) || f.path === name;
  let targetFile = availableFiles.find((f) => !f.isSymlink && matchesFilename(f, filename));
  if (!targetFile && filename.toLowerCase().endsWith(".gen.gb")) {
    const assemblyFilename = filename.replace(/\.gen\.gb$/i, ".assembly");
    targetFile = availableFiles.find((f) => !f.isSymlink && matchesFilename(f, assemblyFilename));
  }
  if (!targetFile) {
    targetFile = availableFiles.find((f) => f.isSymlink && matchesFilename(f, filename));
  }
  if (!targetFile && filename.toLowerCase().endsWith(".gen.gb")) {
    const assemblyFilename = filename.replace(/\.gen\.gb$/i, ".assembly");
    targetFile = availableFiles.find((f) => f.isSymlink && matchesFilename(f, assemblyFilename));
  }
  return targetFile || null;
}
export function parseYamlContext(fullText, currentLineNumber) {
  let currentMethod = "";
  const usedKeys = /* @__PURE__ */ new Set();
  const lines = (fullText || "").split(/\r?\n/);
  lines.forEach((line, idx) => {
    if (idx === currentLineNumber - 1) return;
    const m = line.match(/^\s*([a-zA-Z0-9_-]+)\s*:/);
    if (m) {
      const key = m[1];
      usedKeys.add(key);
      if (key === "method") {
        const valMatch = line.match(/method\s*:\s*([a-zA-Z0-9_-]+)/);
        if (valMatch) currentMethod = valMatch[1];
      }
    }
  });
  return { currentMethod, usedKeys };
}
export function getAvailableKeys(schema, currentMethod) {
  if (!schema || !schema.properties) return [];
  const props = schema.properties;
  let availableKeys = Object.keys(props);
  if (currentMethod) {
    const conditionalKeys = /* @__PURE__ */ new Set();
    if (schema.allOf) {
      schema.allOf.forEach((rule) => {
        if (rule.then && rule.then.properties) {
          Object.keys(rule.then.properties).forEach((k) => conditionalKeys.add(k));
        }
        if (rule.then && rule.then.required) {
          rule.then.required.forEach((k) => conditionalKeys.add(k));
        }
      });
    }
    availableKeys = Object.keys(props).filter((k) => !conditionalKeys.has(k) || k === "method");
    if (schema.allOf) {
      schema.allOf.forEach((rule) => {
        if (rule.if && rule.if.properties && rule.if.properties.method && rule.if.properties.method.const === currentMethod) {
          if (rule.then) {
            if (rule.then.properties) {
              availableKeys = [.../* @__PURE__ */ new Set([...availableKeys, ...Object.keys(rule.then.properties)])];
            }
            if (rule.then.required) {
              availableKeys = [.../* @__PURE__ */ new Set([...availableKeys, ...rule.then.required])];
            }
          }
        }
      });
    }
  }
  return availableKeys;
}
export function getParentKey(lines, currentLineNumber, textUntilCursor, keyMatch, listMatch) {
  let parentKey = "";
  if (keyMatch) {
    parentKey = keyMatch[1].toLowerCase();
    if (parentKey === "sequence") {
      const currentIndent = textUntilCursor.search(/\S/);
      for (let i = currentLineNumber - 2; i >= 0; i--) {
        const prevLine = lines[i];
        if ((prevLine || "").trim() === "") continue;
        const prevLineIndent = prevLine.search(/\S/);
        if (prevLineIndent < currentIndent) {
          const m = prevLine.match(/^\s*([a-zA-Z0-9_-]+)\s*:/);
          if (m) {
            const grandParentKey = m[1].toLowerCase();
            if (grandParentKey === "dest_primer_fwd" || grandParentKey === "dest_primer_rvs") {
              return "primer";
            }
          }
          break;
        }
      }
    }
  } else if (listMatch) {
    const currentIndent = textUntilCursor.search(/\S/);
    for (let i = currentLineNumber - 2; i >= 0; i--) {
      const prevLine = lines[i];
      if ((prevLine || "").trim() === "") continue;
      const prevLineIndent = prevLine.search(/\S/);
      if (prevLineIndent < currentIndent) {
        const m = prevLine.match(/^\s*([a-zA-Z0-9_-]+)\s*:/);
        if (m) parentKey = m[1].toLowerCase();
        break;
      }
    }
  } else {
    const currentIndent = textUntilCursor.length;
    if (currentIndent > 0) {
      for (let i = currentLineNumber - 2; i >= 0; i--) {
        const prevLine = lines[i];
        const trimmed = (prevLine || "").trim();
        if (trimmed === "" || trimmed.startsWith("#")) continue;
        const prevLineIndent = prevLine.search(/\S/);
        if (prevLineIndent < currentIndent) {
          const m = prevLine.match(/^\s*(?:-\s+)?([a-zA-Z0-9_-]+)\s*:/);
          if (m) {
            const detected = m[1].toLowerCase();
            if (prevLine.trim().startsWith("-") && detected === "before") {
              return "mutation_item";
            }
            if (detected === "after") {
              return "mutations";
            }
            return detected;
          }
          break;
        }
      }
    }
  }
  if (parentKey === "dest_primer_fwd" || parentKey === "dest_primer_rvs" || parentKey === "fwd" || parentKey === "rvs" || parentKey === "rev" || parentKey.endsWith("_fwd") || parentKey.endsWith("_rvs") || parentKey.endsWith("_rev")) {
    if (parentKey === "fwd" || parentKey === "rvs" || parentKey === "rev" || parentKey.endsWith("_fwd") || parentKey.endsWith("_rvs") || parentKey.endsWith("_rev")) {
      const currentIndent = textUntilCursor.search(/\S/);
      let isInsidePrimerPairs = false;
      for (let i = currentLineNumber - 2; i >= 0; i--) {
        const prevLine = lines[i];
        if ((prevLine || "").trim() === "") continue;
        const prevLineIndent = prevLine.search(/\S/);
        if (prevLineIndent < currentIndent) {
          if (prevLine.trim().toLowerCase().startsWith("primer_pairs:")) {
            isInsidePrimerPairs = true;
            break;
          }
        }
      }
      if (isInsidePrimerPairs) return "primer";
      if (parentKey === "dest_primer_fwd" || parentKey === "dest_primer_rvs") return "primer";
      if (parentKey === "fwd" || parentKey === "rvs" || parentKey === "rev") return "primer";
      return parentKey;
    }
    return "primer";
  }
  return parentKey;
}
export function filterAvailableFiles(availableFiles, parentKey, typedSoFar, extensions) {
  const term = (typedSoFar || "").trim().toLowerCase();
  const PRIMER_FOLDER = "shared_parts/primers";
  const terms = term.split(/\s+/).filter(Boolean);
  return (availableFiles || []).filter((file) => {
    if (file.isSymlink) return false;
    const isSeq = extensions.some((ex) => file.name.toLowerCase().endsWith(ex));
    if (!isSeq) return false;
    if (parentKey === "primer") {
      if (!file.path.includes(PRIMER_FOLDER)) return false;
    }
    if (parentKey === "vector" && !file.circular) return false;
    if (terms.length === 0) return true;
    const normalizedName = file.name.toLowerCase().replace(/[_\/\\\\]/g, " ");
    const normalizedDesc = (file.description || "").toLowerCase().replace(/[_\/\\\\]/g, " ");
    const combined = `${normalizedName} ${normalizedDesc}`;
    return terms.every((t) => combined.includes(t));
  });
}
export function getExistingEnzymes(lines, currentLineNumber) {
  const existingEnzymes = /* @__PURE__ */ new Set();
  let inEnzymesBlock = false;
  let enzymesIndent = -1;
  (lines || []).forEach((line, idx) => {
    if (idx === currentLineNumber - 1) return;
    const trimmed = line.trim();
    if (trimmed === "") return;
    const keyMatch = line.match(/^(\s*)enzymes\s*:/);
    if (keyMatch) {
      inEnzymesBlock = true;
      enzymesIndent = keyMatch[1].length;
      return;
    }
    if (inEnzymesBlock) {
      const currentIndent = line.search(/\S/);
      if (currentIndent <= enzymesIndent) {
        inEnzymesBlock = false;
        return;
      }
      const itemMatch = line.match(/^\s*-\s+([a-zA-Z0-9_-]+)/);
      if (itemMatch) {
        existingEnzymes.add(itemMatch[1]);
      }
    }
  });
  return existingEnzymes;
}
export const FILE_EXTENSIONS_REGEX = "(?:gen\\.gb|genbank|gbk|gb|fasta|fa|assembly)";
export function extractFileMatches(lineContent) {
  if (!lineContent) return [];
  const matches = [];
  const occupiedRanges = [];
  const isOverlapping = (start, end) => {
    return occupiedRanges.some(([s, e]) => Math.max(start, s) < Math.min(end, e));
  };
  const quotedRegex = new RegExp(
    `"([^"\\r\\n]+\\.${FILE_EXTENSIONS_REGEX})"|'([^'\\r\\n]+\\.${FILE_EXTENSIONS_REGEX})'`,
    "gi"
  );
  let match;
  while ((match = quotedRegex.exec(lineContent)) !== null) {
    const filename = match[1] || match[2];
    const startColumn = match.index + 1 + 1;
    const endColumn = startColumn + filename.length;
    matches.push({ filename, startColumn, endColumn });
    occupiedRanges.push([match.index + 1, match.index + 1 + match[0].length]);
  }
  const yamlScalarRegex = new RegExp(
    `^(\\s*(?:-\\s+|[a-zA-Z0-9_-]+\\s*:\\s+))([^\\s"'].*?\\.${FILE_EXTENSIONS_REGEX})(?=\\s*(?:#|$))`,
    "i"
  );
  const scalarMatch = yamlScalarRegex.exec(lineContent);
  if (scalarMatch) {
    const prefix = scalarMatch[1];
    const rawVal = scalarMatch[2];
    const filename = rawVal.trim();
    const leadingWhitespaceOffset = rawVal.indexOf(filename);
    const startColumn = prefix.length + leadingWhitespaceOffset + 1;
    const endColumn = startColumn + filename.length;
    if (!isOverlapping(startColumn, endColumn)) {
      matches.push({ filename, startColumn, endColumn });
      occupiedRanges.push([startColumn, endColumn]);
    }
  }
  const tokenRegex = new RegExp(
    `([a-zA-Z0-9_.\\-+@~%/()][^\\s"'#:,[\\]{}<>]*\\.${FILE_EXTENSIONS_REGEX})(?![a-zA-Z0-9_])`,
    "gi"
  );
  while ((match = tokenRegex.exec(lineContent)) !== null) {
    const filename = match[1];
    const startColumn = match.index + 1;
    const endColumn = startColumn + filename.length;
    if (!isOverlapping(startColumn, endColumn)) {
      matches.push({ filename, startColumn, endColumn });
      occupiedRanges.push([startColumn, endColumn]);
    }
  }
  matches.sort((a, b) => a.startColumn - b.startColumn);
  return matches;
}
